import React, { useEffect, useState, Fragment, createElement, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Modal Component
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-0">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-1" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-2">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden pointer-events-auto" data-id="element-3">
              {/* Header */}
              <div className="bg-deepDark px-6 py-5 flex items-center justify-between sticky top-0 z-10" data-id="element-4">
                <h2 className="font-playfair text-white text-xl md:text-2xl" data-id="element-5">
                  {title}
                </h2>
                <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors text-2xl leading-none" aria-label="Cerrar" data-id="element-6">
                  ×
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto max-h-[calc(85vh-80px)] p-6 md:p-8" data-id="element-7">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}
function Home() {
  // Countdown timer state
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 9
  });
  // FAQ accordion state
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Units left counter (simulated scarcity)
  const [unitsLeft] = useState(23);
  // Modal state
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | null>(null);
  // Initialize Meta Pixel and fire PageView
  useEffect(() => {
    // Load Meta Pixel script
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '1377433624081067');
    window.fbq('track', 'PageView');
  }, []);
  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          return {
            minutes: 14,
            seconds: 9
          }; // Reset when reaches 0
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const scrollToCta = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  // Handle payment button click with Meta Pixel tracking
  const handlePaymentClick = () => {
    // Fire AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Reinicio Biológico',
        content_ids: ['reinicio-biologico'],
        content_type: 'product',
        value: 26.0,
        currency: 'EUR'
      });
    }
    // Open Hotmart payment page
    window.open('https://pay.hotmart.com/W104988940M?bid=1774468896416', '_blank');
  };
  return <div className="w-full min-h-screen bg-white font-inter" data-id="element-8">
      {/* SECTION 1: STICKY URGENCY BAR */}
      <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-urgencyRed-start to-urgencyRed-end animate-gradient text-white py-3 px-4 md:py-4 shadow-lg" data-id="element-9">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4" data-id="element-10">
          <div className="flex items-center gap-2 text-xs md:text-sm font-semibold" data-id="element-11">
            <span className="text-lg" data-id="element-12">⚡</span>
            <span className="uppercase tracking-wide" data-id="element-13">
              OFERTA DE LANZAMIENTO — SOLO QUEDAN {unitsLeft} UNIDADES
            </span>
          </div>

          <div className="flex items-center gap-2 bg-red-900 px-4 py-2 rounded-lg font-bold text-sm md:text-base" data-id="element-14">
            <span className="text-xs md:text-sm" data-id="element-15">EXPIRA EN:</span>
            <span className="text-white text-lg md:text-xl tabular-nums" data-id="element-16">
              00:{String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>

          <button onClick={handlePaymentClick} className="w-full md:w-auto bg-gradient-to-r from-gold to-gold-light text-deepDark font-bold px-6 py-3 rounded-full hover:scale-105 transition-transform text-sm md:text-base whitespace-nowrap" data-id="element-17">
            CONSEGUIR POR 26€ →
          </button>
        </div>
      </div>

      {/* SECTION 2: HERO SECTION */}
      <section className="relative w-full bg-deepDark noise-texture py-16 md:py-24 px-4" data-id="element-18">
        <div className="max-w-4xl mx-auto text-center" data-id="element-19">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-gold text-xs md:text-sm uppercase tracking-widest-xl mb-6 font-semibold" data-id="element-20">
            EL PROTOCOLO QUE NADIE EN ESPAÑA TE HABÍA CONTADO
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="font-playfair text-white text-3xl md:text-5xl leading-tight mb-6" data-id="element-21">
            ¿Por qué te sientes agotado, hinchado y sin foco... aunque 'hagas
            todo bien'?
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-gold text-xl md:text-2xl mb-8 font-semibold" data-id="element-22">
            No es tu edad. No es el estrés. Es Inflamación Silenciosa
            destruyendo tu biología.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="text-white text-base md:text-lg leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-23">
            Tu cuerpo está librando una guerra invisible 24 horas al día.
            Microorganismos oportunistas en tu intestino están secuestrando tu
            energía, nublando tu cerebro y deformando tu vientre. El Reinicio
            Biológico apaga ese incendio interno en solo 14 días. Sin dietas
            extremas. Sin pastillas. Solo protocolo técnico basado en ciencia
            real.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="mb-12" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png" alt="El Reinicio Biológico - Protocolo de 14 Días" className="w-full max-w-sm md:max-w-md mx-auto animate-float" data-id="element-25" />
          </motion.div>

          <div className="mb-8" data-id="element-26">
            <p className="text-red-500 text-lg md:text-xl mb-2" data-id="element-27">
              <span className="price-strike" data-id="element-28">Valor total: 205€</span>
            </p>
            <p className="text-gold text-4xl md:text-6xl font-playfair font-bold mb-2 animate-pulse-glow" data-id="element-29">
              HOY SOLO: 26€
            </p>
            <p className="text-gray-400 text-sm" data-id="element-30">
              (IVA incluido. Acceso inmediato.)
            </p>
          </div>

          <button onClick={handlePaymentClick} className="w-full md:w-auto bg-gradient-to-r from-gold to-gold-light text-deepDark font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full gold-glow btn-hover mb-6" data-id="element-31">
            🚀 SÍ, QUIERO MI REINICIO — 26€
          </button>

          <p className="text-gray-400 text-sm mb-8" data-id="element-32">
            🔒 Pago 100% seguro · Acceso instantáneo · Garantía 7 días
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-33">
            {['🔒 Pago Seguro', '⚡ Acceso Inmediato', '↩️ Garantía 7 Días', '🇪🇸 Creado en España'].map((badge, index) => <span key={index} className="bg-emerald-light text-gold px-4 py-2 rounded-full text-xs md:text-sm font-semibold whitespace-nowrap" data-id="element-34">
                {badge}
              </span>)}
          </div>
        </div>
      </section>

      {/* SECTION 3: PAIN AMPLIFICATION */}
      <section className="w-full bg-deepDark py-16 md:py-24 px-4" data-id="element-35">
        <div className="max-w-6xl mx-auto" data-id="element-36">
          <p className="text-gold text-xs md:text-sm uppercase tracking-widest text-center mb-6 font-semibold" data-id="element-37">
            ¿TE IDENTIFICAS CON ESTO?
          </p>

          <h2 className="font-playfair text-white text-2xl md:text-4xl text-center mb-4 max-w-3xl mx-auto leading-tight" data-id="element-38">
            "Pensé que estar cansada, hinchada y sin energía... era simplemente
            parte de hacerse mayor."
          </h2>

          <p className="text-gold italic text-lg md:text-xl text-center mb-12" data-id="element-39">
            — Lo que nadie te dijo es que hay una causa real. Y tiene solución.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-12" data-id="element-40">
            {[{
            icon: '🧠',
            title: 'La Neblina Mental Constante',
            text: 'Te cuesta concentrarte más de 20 minutos. Olvidas cosas simples. Sientes que tu cerebro funciona al 40% de su capacidad. Y el café ya no ayuda.'
          }, {
            icon: '😴',
            title: 'Despiertas Agotado/a',
            text: 'Duermes 8 horas y amaneces destrozado/a. Tu cuerpo no descansa porque por dentro hay un incendio activo que consume toda tu energía de recuperación.'
          }, {
            icon: '👖',
            title: 'El Vientre que Crece Después de Comer',
            text: 'Comes "sano" pero a las 6 PM tu abdomen parece un globo. No es lo que comes, es lo que tu flora intestinal destruida no puede procesar.'
          }, {
            icon: '😤',
            title: 'Los Antojos que No Puedes Controlar',
            text: 'No es falta de voluntad. Son bacterias oportunistas en tu intestino enviando señales falsas a tu cerebro para que les alimentes con azúcar.'
          }, {
            icon: '🎭',
            title: 'El Humor que Cambia Sin Razón',
            text: 'Irritabilidad, ansiedad leve, bajones emocionales. El 95% de la serotonina se produce en el intestino. Si tu intestino está en guerra, tu mente también.'
          }, {
            icon: '⚖️',
            title: 'El Peso que No Se Va',
            text: 'Haces dieta, haces ejercicio, y la báscula no se mueve. La inflamación sistémica bloquea activamente las hormonas que regulan tu metabolismo.'
          }].map((card, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-emerald-light border border-gold/20 rounded-2xl p-6 hover:border-gold transition-colors" data-id="element-41">
                <div className="text-4xl mb-4" data-id="element-42">{card.icon}</div>
                <h3 className="text-gold font-bold text-lg mb-3" data-id="element-43">
                  {card.title}
                </h3>
                <p className="text-white text-sm md:text-base leading-relaxed" data-id="element-44">
                  {card.text}
                </p>
              </motion.div>)}
          </div>

          <p className="text-white text-center italic text-base md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-45">
            Si reconoces 2 o más de estos síntomas, tu cuerpo lleva meses
            enviándote señales de auxilio. Cada día que pasa sin actuar, el
            incendio interno se hace más difícil de apagar.
          </p>
        </div>
      </section>

      {/* SECTION 4: THE MECHANISM */}
      <section className="w-full bg-offWhite py-16 md:py-24 px-4" data-id="element-46">
        <div className="max-w-6xl mx-auto" data-id="element-47">
          <p className="text-emerald text-xs md:text-sm uppercase tracking-widest text-center mb-6 font-semibold" data-id="element-48">
            LA CAUSA RAÍZ QUE NADIE TE EXPLICA
          </p>

          <h2 className="font-playfair text-deepDark text-2xl md:text-4xl text-center mb-16 leading-tight" data-id="element-49">
            El Problema No Es Tu Fuerza de Voluntad.
            <br data-id="element-50" />
            Es Tu Microbioma Destruido.
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-6 mb-16" data-id="element-51">
            {[{
            icon: '🦠',
            title: 'EL DETONANTE',
            text: 'Azúcares ocultos, aceites procesados y aditivos en productos "fit" destruyen tu barrera intestinal silenciosamente.'
          }, {
            icon: '🔥',
            title: 'EL INCENDIO',
            text: 'Las bacterias oportunistas colonizan tu intestino y generan inflamación sistémica crónica que afecta cerebro, metabolismo y energía.'
          }, {
            icon: '💊',
            title: 'EL ERROR',
            text: 'Tratamos los síntomas (café, ibuprofeno, dietas) en lugar de apagar el incendio en la raíz. El ciclo nunca termina.'
          }].map((step, index) => <Fragment key={index} data-id="element-52">
                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="flex-1 text-center" data-id="element-53">
                  <div className="text-5xl md:text-6xl mb-4" data-id="element-54">{step.icon}</div>
                  <h3 className="text-emerald font-bold text-lg md:text-xl mb-3 uppercase tracking-wide" data-id="element-55">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-56">
                    {step.text}
                  </p>
                </motion.div>
                {index < 2 && <div className="text-gold text-3xl md:text-4xl font-bold hidden md:block" data-id="element-57">
                    →
                  </div>}
                {index < 2 && <div className="text-gold text-3xl md:text-4xl font-bold md:hidden" data-id="element-58">
                    ↓
                  </div>}
              </Fragment>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-emerald rounded-3xl p-8 md:p-12 text-center" data-id="element-59">
            <h3 className="font-playfair text-gold text-2xl md:text-3xl mb-6" data-id="element-60">
              El Reinicio Biológico interrumpe ese ciclo en 14 días.
            </h3>
            <p className="text-white text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-61">
              No es una dieta. No es un suplemento. Es un protocolo técnico de
              reprogramación del microbioma que actúa directamente sobre la
              causa raíz — no sobre los síntomas.
            </p>
          </motion.div>
        </div>
      </section>

      {/* SECTION 5: SOCIAL PROOF */}
      <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-62">
        <div className="max-w-6xl mx-auto" data-id="element-63">
          <p className="text-gold text-xs md:text-sm uppercase tracking-widest text-center mb-6 font-semibold" data-id="element-64">
            RESULTADOS REALES DE PERSONAS REALES EN ESPAÑA
          </p>

          <h2 className="font-playfair text-deepDark text-2xl md:text-4xl text-center mb-4" data-id="element-65">
            Más de 1.200 personas ya iniciaron su Reinicio
          </h2>

          <p className="text-gray-600 text-center mb-12" data-id="element-66">
            Estos son algunos de sus mensajes reales:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-67">
            {[{
            name: 'Lucía M. — Madrid',
            message: 'Día 4 y la neblina mental desapareció por completo. Llevo años sin sentirme tan lúcida en el trabajo. ¿Cómo no me enteré antes de esto? 🤯',
            time: '10:42 AM · Ayer'
          }, {
            name: 'Paco R. — Sevilla',
            message: 'El pantalón que no me cerraba desde hace 2 años... me lo puse hoy sin esfuerzo. Día 9. No me lo creo. El vientre por fin normal después de comer 🙌',
            time: '16:15 PM · Hace 2 días'
          }, {
            name: 'Ana C. — Barcelona',
            message: 'Empecé con mucho escepticismo. Pero en el día 6 me di cuenta de que llevaba días sin necesitar la siesta de las 3. Esto es diferente a todo lo que había probado antes. Increíble.',
            time: '20:30 PM · Hace 3 días'
          }, {
            name: 'Roberto S. — Valencia',
            message: 'Los antojos de azúcar desaparecieron casi de golpe. Mi mujer me pregunta qué estoy tomando 😂 Le he mandado el enlace. Ojalá lo hubiera encontrado hace 5 años.',
            time: '09:15 AM · Hace 4 días'
          }].map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-soft overflow-hidden" data-id="element-68">
                <div className="whatsapp-header px-4 py-3 flex items-center gap-3" data-id="element-69">
                  <div className="w-10 h-10 rounded-full bg-gold flex items-center justify-center text-white font-bold" data-id="element-70">
                    {testimonial.name[0]}
                  </div>
                  <div className="flex-1" data-id="element-71">
                    <p className="text-white font-semibold text-sm flex items-center gap-2" data-id="element-72">
                      {testimonial.name}
                      <span className="text-blue-400" data-id="element-73">✓</span>
                    </p>
                  </div>
                </div>
                <div className="p-6" data-id="element-74">
                  <div className="whatsapp-bubble p-4 mb-3" data-id="element-75">
                    <p className="text-gray-800 text-sm md:text-base leading-relaxed" data-id="element-76">
                      {testimonial.message}
                    </p>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-77">
                    <p className="text-gray-500 text-xs" data-id="element-78">{testimonial.time}</p>
                    <div className="flex gap-1" data-id="element-79">
                      {[...Array(5)].map((_, i) => <span key={i} className="text-gold" data-id="element-80">
                          ⭐
                        </span>)}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 pt-8 border-t border-gray-200" data-id="element-81">
            {[{
            number: '1.200+',
            label: 'Personas'
          }, {
            number: '4.8/5',
            label: 'Valoración Media'
          }, {
            number: '97%',
            label: 'Repiten'
          }].map((stat, index) => <div key={index} className="text-center" data-id="element-82">
                <p className="text-gold text-3xl md:text-4xl font-playfair font-bold mb-1" data-id="element-83">
                  {stat.number}
                </p>
                <p className="text-gray-600 text-sm md:text-base" data-id="element-84">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 6: OFFER STACK */}
      <section className="w-full bg-offWhite py-16 md:py-24 px-4" data-id="element-85">
        <div className="max-w-5xl mx-auto" data-id="element-86">
          <p className="text-gold text-xs md:text-sm uppercase tracking-widest text-center mb-6 font-semibold" data-id="element-87">
            TODO LO QUE RECIBES HOY
          </p>

          <h2 className="font-playfair text-deepDark text-2xl md:text-4xl text-center mb-12" data-id="element-88">
            Acceso Completo al Sistema Zeklo
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-89">
            {[{
            icon: '📗',
            image: 'https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png',
            name: 'Libro "El Reinicio Biológico"',
            description: 'El protocolo técnico de 14 días. Tu manual de batalla completo.',
            value: '97€'
          }, {
            icon: '🗺️',
            image: 'https://cdn.magicpatterns.com/uploads/2tnd4ucKUWpTuffMabV8WU/BONO_1_(1)_(1).webp',
            name: 'BONO 1 — Hoja de Ruta',
            description: 'Tu guía paso a paso, día a día. Cero dudas. Cero improvisación.',
            value: '27€'
          }, {
            icon: '🥗',
            image: 'https://cdn.magicpatterns.com/uploads/1ANDgCzmuhPzhs35EPv9LL/BONO_2_(1)_(1).webp',
            name: 'BONO 2 — Recetario Express',
            description: 'Comidas de menos de 10 minutos que alimentan tu biología, no la inflamación.',
            value: '47€'
          }, {
            icon: '⚠️',
            image: 'https://cdn.magicpatterns.com/uploads/nYyhZ1KyrmYFNpFP79odtJ/BONO_3_(2).webp',
            name: 'BONO 3 — Guía de Saboteadores',
            description: 'Todos los ingredientes ocultos en tu despensa que están destruyendo tu esfuerzo en el supermercado.',
            value: '17€'
          }, {
            icon: '🛒',
            image: 'https://cdn.magicpatterns.com/uploads/xBeJt6bGpHWh86cqtUaqGA/BONO_4_(1)_(1).webp',
            name: 'BONO 4 — Lista de Compras Inteligente',
            description: 'El inventario exacto para empezar desde hoy. Nada que inventarse.',
            value: '17€'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-5 border-l-4 border-gold shadow-card flex gap-4" data-id="element-90">
                <img src={item.image} alt={item.name} className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0" data-id="element-91" />
                <div className="flex-1" data-id="element-92">
                  <h3 className="text-deepDark font-bold text-base md:text-lg mb-2" data-id="element-93">
                    {item.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3 leading-relaxed" data-id="element-94">
                    {item.description}
                  </p>
                  <span className="inline-block bg-gold/20 text-gold px-3 py-1 rounded-full text-xs font-semibold" data-id="element-95">
                    Valor: {item.value}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-deepDark rounded-3xl p-8 md:p-12 text-center" data-id="element-96">
            <p className="text-gray-400 text-sm uppercase tracking-wider mb-2" data-id="element-97">
              VALOR TOTAL DEL SISTEMA:
            </p>
            <p className="text-red-500 text-2xl md:text-3xl mb-4" data-id="element-98">
              <span className="price-strike" data-id="element-99">205€</span>
            </p>
            <p className="text-gold text-base uppercase tracking-wider mb-2" data-id="element-100">
              TU INVERSIÓN HOY:
            </p>
            <p className="text-white text-5xl md:text-7xl font-playfair font-bold mb-6" data-id="element-101">
              26€
            </p>
            <p className="text-gray-400 text-sm mb-8" data-id="element-102">(IVA incluido)</p>

            <button onClick={handlePaymentClick} className="w-full bg-gradient-to-r from-gold to-gold-light text-deepDark font-bold text-lg md:text-xl px-8 py-5 rounded-full gold-glow-strong btn-hover mb-4" data-id="element-103">
              🚀 QUIERO ACCESO COMPLETO — 26€
            </button>

            <p className="text-gray-400 text-sm" data-id="element-104">
              ⚡ Acceso inmediato tras el pago
            </p>
          </motion.div>
        </div>
      </section>

      {/* SECTION 7: FAQ ACCORDION */}
      <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-105">
        <div className="max-w-3xl mx-auto" data-id="element-106">
          <h2 className="font-playfair text-deepDark text-2xl md:text-4xl text-center mb-12" data-id="element-107">
            Tus Preguntas. Respondidas con Honestidad.
          </h2>

          <div className="space-y-4" data-id="element-108">
            {[{
            question: '¿Funciona aunque lleve años con estos síntomas?',
            answer: 'Sí. El protocolo actúa a nivel del microbioma, que se regenera independientemente del tiempo que lleves con inflamación. De hecho, muchos usuarios con síntomas crónicos reportan los cambios más rápidos y dramáticos.'
          }, {
            question: '¿Tengo que hacer dieta estricta o pasar hambre?',
            answer: 'Absolutamente no. El Reinicio Biológico no es una dieta restrictiva. Es un protocolo de alimentación inteligente que saciará más y te dará más energía — no menos.'
          }, {
            question: '¿En cuánto tiempo veré resultados reales?',
            answer: 'La mayoría de usuarios reporta los primeros cambios entre el día 3 y el día 7. La claridad mental suele ser lo primero. El vientre y la energía, antes del día 14.'
          }, {
            question: '¿Es apto para hombres y mujeres?',
            answer: '100%. La inflamación sistémica no discrimina. El protocolo está diseñado para funcionar en cualquier perfil biológico adulto.'
          }, {
            question: '¿Qué pasa si no funciona para mí?',
            answer: 'Tienes 7 días completos para probarlo. Si no sientes la diferencia, te devolvemos el 100% del dinero. Sin preguntas. Sin formularios complicados.'
          }, {
            question: '¿Cómo accedo después del pago?',
            answer: 'Inmediatamente. Recibirás un email con acceso a tu área de descarga en menos de 2 minutos. Compatible con móvil, tablet y ordenador.'
          }].map((faq, index) => <div key={index} className="border-b border-gray-200 last:border-b-0" data-id="element-109">
                <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between py-5 text-left hover:text-gold transition-colors" data-id="element-110">
                  <span className="text-deepDark font-bold text-base md:text-lg pr-4" data-id="element-111">
                    {faq.question}
                  </span>
                  <span className="text-gold text-2xl flex-shrink-0" data-id="element-112">
                    {openFaq === index ? '−' : '+'}
                  </span>
                </button>
                {openFaq === index && <div className="pb-5 accordion-content" data-id="element-113">
                    <p className="text-gray-600 text-sm md:text-base leading-relaxed bg-offWhite p-4 rounded-lg" data-id="element-114">
                      {faq.answer}
                    </p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 8: GUARANTEE */}
      <section className="w-full bg-deepDark py-16 md:py-20 px-4" data-id="element-115">
        <div className="max-w-2xl mx-auto text-center" data-id="element-116">
          <div className="text-6xl md:text-7xl mb-6" data-id="element-117">🛡️</div>

          <h2 className="font-playfair text-gold text-2xl md:text-4xl mb-8" data-id="element-118">
            La Garantía Zeklo: Sin Riesgo. Sin Trampa.
          </h2>

          <p className="text-white text-base md:text-lg leading-relaxed mb-8" data-id="element-119">
            Tienes 7 días para probarlo todo. Aplica el protocolo. Siente la
            diferencia.
            <br data-id="element-120" />
            <br data-id="element-121" />
            Si después de 7 días no notas ningún cambio, te devolvemos el 100%
            de tu dinero. Sin preguntas. Sin formularios imposibles. Sin
            esperas. Solo un email y listo.
          </p>

          <p className="text-gold italic text-lg md:text-xl font-semibold" data-id="element-122">
            El riesgo es nuestro. El resultado es tuyo.
          </p>
        </div>
      </section>

      {/* SECTION 9: FINAL CTA */}
      <section className="w-full bg-gradient-to-b from-deepDark to-emerald py-16 md:py-24 px-4" data-id="element-123">
        <div className="max-w-3xl mx-auto text-center" data-id="element-124">
          <h2 className="font-playfair text-white text-2xl md:text-4xl mb-8" data-id="element-125">
            ¿Cuánto más vas a esperar?
          </h2>

          <p className="text-white text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-126">
            Cada día que pasa con inflamación activa, la neblina crece. El
            vientre empeora. La energía se agota más. No es dramático — es
            biología.
          </p>

          <ul className="text-gold text-left max-w-xl mx-auto mb-8 space-y-3" data-id="element-127">
            <li className="flex items-start gap-3" data-id="element-128">
              <span className="text-xl" data-id="element-129">•</span>
              <span data-id="element-130">Otro día despertando destrozado/a</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-131">
              <span className="text-xl" data-id="element-132">•</span>
              <span data-id="element-133">Otra tarde con el vientre hinchado</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-134">
              <span className="text-xl" data-id="element-135">•</span>
              <span data-id="element-136">Otra reunión sin poder concentrarte</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-137">
              <span className="text-xl" data-id="element-138">•</span>
              <span data-id="element-139">Otro año sin ser quien realmente eres</span>
            </li>
          </ul>

          <p className="text-white italic text-lg md:text-xl mb-12" data-id="element-140">
            O puedes elegir diferente. Hoy. Por 26€.
          </p>

          <div className="bg-white/5 border-2 border-gold rounded-3xl p-8 md:p-10 mb-8" data-id="element-141">
            <p className="text-red-500 text-xl md:text-2xl mb-3" data-id="element-142">
              <span className="price-strike" data-id="element-143">205€</span>
            </p>
            <p className="text-gold text-4xl md:text-6xl font-playfair font-bold mb-3" data-id="element-144">
              HORA DE REINICIAR: 26€
            </p>
            <p className="text-gray-300 text-sm mb-8" data-id="element-145">
              (IVA incluido · Acceso inmediato)
            </p>

            <button onClick={handlePaymentClick} className="w-full bg-gradient-to-r from-gold to-gold-light text-deepDark font-bold text-lg md:text-2xl px-8 py-6 rounded-full gold-glow-strong animate-pulse-glow btn-hover mb-6" data-id="element-146">
              ⚡ SÍ, QUIERO MI REINICIO BIOLÓGICO — 26€
            </button>

            <div className="space-y-2 text-gray-300 text-xs md:text-sm" data-id="element-147">
              <p data-id="element-148">🔒 Pago 100% seguro</p>
              <p data-id="element-149">📱 Acceso instantáneo en móvil y ordenador</p>
              <p data-id="element-150">↩️ Garantía de devolución 7 días sin preguntas</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10: FOOTER */}
      <footer className="w-full bg-nearBlack py-12 px-4" data-id="element-151">
        <div className="max-w-4xl mx-auto text-center" data-id="element-152">
          <div className="mb-6 flex justify-center" data-id="element-153"></div>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-gray-400 text-xs md:text-sm mb-6" data-id="element-154">
            <button onClick={() => setOpenModal('terms')} className="hover:text-gold transition-colors" data-id="element-155">
              Términos y Condiciones
            </button>
            <span className="hidden md:inline" data-id="element-156">·</span>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-gold transition-colors" data-id="element-157">
              Política de Privacidad
            </button>
            <span className="hidden md:inline" data-id="element-158">·</span>
            <a href="mailto:zeklo.club@gmail.com" className="hover:text-gold transition-colors" data-id="element-159">
              Contacto
            </a>
          </div>

          <p className="text-gray-500 text-xs md:text-sm mb-4" data-id="element-160">
            © 2026 Zeklo Club. Todos los derechos reservados.
          </p>

          <p className="text-gray-600 text-xs italic max-w-2xl mx-auto leading-relaxed" data-id="element-161">
            Este producto no sustituye el consejo médico profesional. Los
            resultados individuales pueden variar según la persona.
          </p>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-162">
        <div className="text-gray-700 space-y-6 leading-relaxed" data-id="element-163">
          <p className="text-gray-500 text-sm mb-6" data-id="element-164">
            Última actualización: Marzo 2026
          </p>

          <section data-id="element-165">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-166">
              1. Introducción
            </h3>
            <p data-id="element-167">
              Bienvenido a Zeklo Club. Al acceder y utilizar nuestro sitio web y
              adquirir "El Reinicio Biológico", aceptas estar sujeto a los
              siguientes términos y condiciones. Te rogamos que los leas
              detenidamente antes de realizar cualquier compra o utilizar
              nuestros servicios.
            </p>
          </section>

          <section data-id="element-168">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-169">
              2. Descripción del Servicio
            </h3>
            <p data-id="element-170">
              Zeklo Club ofrece productos digitales, específicamente el
              protocolo "El Reinicio Biológico", que incluye un libro digital y
              varios bonos complementarios. Al tratarse de un producto digital,
              el acceso se otorga de manera inmediata tras la confirmación del
              pago.
            </p>
          </section>

          <section data-id="element-171">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-172">
              3. Obligaciones del Usuario
            </h3>
            <p className="mb-3" data-id="element-173">
              Al utilizar nuestros servicios, el usuario se compromete a:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-174">
              <li data-id="element-175">
                Ser mayor de 18 años o contar con el consentimiento de un tutor
                legal.
              </li>
              <li data-id="element-176">
                Proporcionar información veraz y actualizada durante el proceso
                de compra.
              </li>
              <li data-id="element-177">
                No distribuir, revender ni compartir el material digital
                adquirido, el cual es de uso estrictamente personal.
              </li>
              <li data-id="element-178">
                Consultar con un profesional de la salud antes de iniciar
                cualquier cambio significativo en su dieta o estilo de vida.
              </li>
            </ul>
          </section>

          <section data-id="element-179">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-180">
              4. Condiciones de Pago
            </h3>
            <p data-id="element-181">
              El precio del producto es de 26€ (IVA incluido). Los pagos se
              procesan de manera segura a través de plataformas de terceros
              (Redsys, Stripe o PayPal). Zeklo Club no almacena los datos de tu
              tarjeta de crédito.
            </p>
          </section>

          <section data-id="element-182">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-183">
              5. Política de Reembolso
            </h3>
            <p data-id="element-184">
              Ofrecemos una garantía de devolución de 7 días. Si durante los
              primeros 7 días tras tu compra consideras que el protocolo no es
              para ti, puedes solicitar el reembolso íntegro enviando un correo
              a nuestra dirección de contacto. El reembolso se procesará sin
              preguntas adicionales.
            </p>
          </section>

          <section data-id="element-185">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-186">
              6. Propiedad Intelectual
            </h3>
            <p data-id="element-187">
              Todo el contenido, diseño, textos, gráficos y materiales
              proporcionados en este sitio web y en los productos digitales son
              propiedad exclusiva de Zeklo Club. Queda estrictamente prohibida
              su reproducción, distribución o modificación sin autorización
              previa por escrito.
            </p>
          </section>

          <section data-id="element-188">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-189">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-190">
              La información proporcionada en "El Reinicio Biológico" tiene
              fines puramente educativos e informativos. No sustituye el
              consejo, diagnóstico o tratamiento médico profesional. Zeklo Club
              no se hace responsable de los resultados individuales, ya que
              estos pueden variar según cada persona.
            </p>
          </section>

          <section data-id="element-191">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-192">
              8. Ley Aplicable
            </h3>
            <p data-id="element-193">
              Estos términos y condiciones se rigen e interpretan de acuerdo con
              las leyes de España. Cualquier disputa que surja en relación con
              estos términos estará sujeta a la jurisdicción exclusiva de los
              tribunales españoles.
            </p>
          </section>

          <section data-id="element-194">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-195">
              9. Contacto
            </h3>
            <p data-id="element-196">
              Si tienes alguna pregunta sobre estos Términos y Condiciones,
              puedes contactarnos en cualquier momento a través de:{' '}
              <a href="mailto:zeklo.club@gmail.com" className="text-gold hover:underline font-semibold" data-id="element-197">
                zeklo.club@gmail.com
              </a>
            </p>
          </section>
        </div>
      </Modal>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-198">
        <div className="text-gray-700 space-y-6 leading-relaxed" data-id="element-199">
          <p className="text-gray-500 text-sm mb-6" data-id="element-200">
            Última actualización: Marzo 2026
          </p>

          <section data-id="element-201">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-202">
              1. Introducción
            </h3>
            <p data-id="element-203">
              En Zeklo Club, valoramos y respetamos tu privacidad. Esta Política
              de Privacidad explica cómo recopilamos, utilizamos, protegemos y
              compartimos tu información personal cuando visitas nuestro sitio
              web y adquieres nuestros productos digitales.
            </p>
          </section>

          <section data-id="element-204">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-205">
              2. Recopilación de Datos
            </h3>
            <p className="mb-3" data-id="element-206">
              Podemos recopilar los siguientes tipos de información:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-207">
              <li data-id="element-208">
                <strong data-id="element-209">Datos de contacto:</strong> Nombre y dirección de correo
                electrónico al realizar una compra.
              </li>
              <li data-id="element-210">
                <strong data-id="element-211">Datos de pago:</strong> Información procesada de forma
                segura a través de nuestros proveedores de pago (Redsys, Stripe,
                PayPal). Nosotros no almacenamos los detalles completos de tu
                tarjeta.
              </li>
              <li data-id="element-212">
                <strong data-id="element-213">Datos de navegación:</strong> Información sobre cómo
                interactúas con nuestro sitio web (dirección IP, tipo de
                navegador, páginas visitadas) mediante el uso de cookies.
              </li>
            </ul>
          </section>

          <section data-id="element-214">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-215">
              3. Uso de los Datos
            </h3>
            <p className="mb-3" data-id="element-216">
              Utilizamos tu información personal para los siguientes fines:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-217">
              <li data-id="element-218">
                Procesar tus pagos y entregar los productos digitales
                adquiridos.
              </li>
              <li data-id="element-219">
                Enviarte correos electrónicos transaccionales (confirmación de
                compra, acceso al producto).
              </li>
              <li data-id="element-220">
                Proporcionar soporte al cliente y responder a tus consultas.
              </li>
              <li data-id="element-221">
                Mejorar nuestro sitio web y personalizar tu experiencia de
                usuario.
              </li>
              <li data-id="element-222">
                Enviarte comunicaciones de marketing (solo si has dado tu
                consentimiento expreso), de las cuales puedes darte de baja en
                cualquier momento.
              </li>
            </ul>
          </section>

          <section data-id="element-223">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-224">
              4. Almacenamiento y Seguridad
            </h3>
            <p data-id="element-225">
              Implementamos medidas de seguridad técnicas y organizativas
              estándar de la industria para proteger tu información personal
              contra el acceso no autorizado, la alteración, divulgación o
              destrucción. Tus datos se almacenan en servidores seguros y solo
              el personal autorizado tiene acceso a ellos.
            </p>
          </section>

          <section data-id="element-226">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-227">
              5. Derechos del Usuario (RGPD)
            </h3>
            <p className="mb-3" data-id="element-228">
              De acuerdo con el Reglamento General de Protección de Datos
              (RGPD), tienes derecho a:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-229">
              <li data-id="element-230">Acceder a los datos personales que tenemos sobre ti.</li>
              <li data-id="element-231">
                Solicitar la rectificación de datos inexactos o incompletos.
              </li>
              <li data-id="element-232">
                Solicitar la eliminación de tus datos personales ("derecho al
                olvido").
              </li>
              <li data-id="element-233">
                Oponerte al procesamiento de tus datos o solicitar la
                restricción del mismo.
              </li>
              <li data-id="element-234">
                Solicitar la portabilidad de tus datos a otro proveedor de
                servicios.
              </li>
            </ul>
            <p className="mt-3" data-id="element-235">
              Para ejercer cualquiera de estos derechos, por favor contáctanos a
              través del correo electrónico proporcionado al final de esta
              política.
            </p>
          </section>

          <section data-id="element-236">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-237">
              6. Cookies
            </h3>
            <p data-id="element-238">
              Utilizamos cookies y tecnologías similares para garantizar el
              funcionamiento básico del sitio web, analizar el tráfico y mejorar
              tu experiencia. Puedes configurar tu navegador para rechazar todas
              las cookies o para que te avise cuando se envíe una cookie, aunque
              esto podría afectar la funcionalidad de ciertas partes del sitio.
            </p>
          </section>

          <section data-id="element-239">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-240">
              7. Terceros
            </h3>
            <p data-id="element-241">
              No vendemos, intercambiamos ni transferimos tu información
              personal a terceros. Esto no incluye a los terceros de confianza
              que nos asisten en la operación de nuestro sitio web, la
              conducción de nuestro negocio o el servicio a nuestros usuarios
              (como pasarelas de pago y proveedores de email marketing), siempre
              que dichas partes acuerden mantener esta información confidencial.
            </p>
          </section>

          <section data-id="element-242">
            <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-243">
              8. Contacto
            </h3>
            <p data-id="element-244">
              Si tienes alguna pregunta, inquietud o solicitud relacionada con
              esta Política de Privacidad o el manejo de tus datos personales,
              no dudes en contactarnos en:{' '}
              <a href="mailto:zeklo.club@gmail.com" className="text-gold hover:underline font-semibold" data-id="element-245">
                zeklo.club@gmail.com
              </a>
            </p>
          </section>
        </div>
      </Modal>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-246">
      <Routes data-id="element-247">
        <Route path="/" element={<Home data-id="element-249" />} data-id="element-248" />
      </Routes>
    </BrowserRouter>;
}